import { usePage } from "@inertiajs/react"
import { Navigation } from "app/navigation"
import React from "react"
import { Messages } from "./components/messages"
import { ApprovalBanner } from "app/account/approval-banner"
import { FreeOverLimitBanner } from "./components/free-over-limit-banner"
import { CancellationPendingBanner } from "./components/cancellation-pending-banner"
import { UnconfirmedUserEmailBanner } from "app/account/unconfirmed-user-email-banner"
import { UnconfirmedSendAddressBanner } from "app/account/unconfirmed-send-address-banner"
import { UnpaidBanner } from "./components/unpaid-banner"
import { TrialEndedBanner } from "./components/trial-ended-banner"
import { RequiredInfoBanner } from "./components/required-info-banner"

/**
 * InertiaPageHeader renders all top-of-page layout elements that were previously
 * rendered server-side in the Rails application layout.
 *
 * This includes navigation, admin header, flash messages, and various alert banners.
 * It reads the shared layout configuration from Inertia props and conditionally
 * renders components based on the current page's requirements.
 */
export function InertiaPageHeader() {
  const {
    props: { layoutConfig }
  } = usePage()

  // Check if Rails-rendered layout sections exist in the DOM
  // This handles the case where a feature flag was enabled while users had existing tabs open
  const railsRenderedLayoutSections = document.getElementById(
    "rails_rendered_layout_sections"
  )

  if (railsRenderedLayoutSections) {
    return null
  }

  return (
    <>
      {layoutConfig.components.navbar.visible && (
        <Navigation {...layoutConfig.components.navbar.data} />
      )}

      {layoutConfig.components.messages.visible && (
        <Messages {...layoutConfig.components.messages.data} />
      )}

      {layoutConfig.components.inReview.visible && (
        <ApprovalBanner {...layoutConfig.components.inReview.data} />
      )}

      {layoutConfig.components.freeOverLimit.visible && (
        <FreeOverLimitBanner {...layoutConfig.components.freeOverLimit.data} />
      )}

      {layoutConfig.components.cancellationPending.visible && (
        <CancellationPendingBanner
          {...layoutConfig.components.cancellationPending.data}
        />
      )}

      {layoutConfig.components.unconfirmedUserEmail.visible && (
        <UnconfirmedUserEmailBanner
          {...layoutConfig.components.unconfirmedUserEmail.data}
        />
      )}

      {layoutConfig.components.unconfirmedSendAddress.visible && (
        <UnconfirmedSendAddressBanner
          {...layoutConfig.components.unconfirmedSendAddress.data}
        />
      )}

      {layoutConfig.components.unpaid.visible && <UnpaidBanner />}

      {layoutConfig.components.trialEnded.visible && <TrialEndedBanner />}

      {layoutConfig.components.requiredInfo.visible && (
        <RequiredInfoBanner {...layoutConfig.components.requiredInfo.data} />
      )}
    </>
  )
}
